import SnowflakeSlashBold from './SnowflakeSlashBold';

export default SnowflakeSlashBold;
